import { Injectable } from '@angular/core';

@Injectable()
export class AppNavbarVerticalService {
    navBarRef;

    constructor() {
    }

    setNavBar(ref) {
        this.navBarRef = ref;
    }

    getNavBar() {
        return this.navBarRef;
    }
}
